import React, { useEffect } from "react";
import { createFileRoute, redirect } from "@tanstack/react-router";

function SettingsRedirectPage() {
  // This will handle the redirect on the client side as well
  useEffect(() => {
    window.location.replace("/dashboard");
  }, []);

  return null;
}

export const Route = createFileRoute("/_user/settings/")({
  beforeLoad: () => {
    throw redirect({
      to: "/dashboard",
      replace: true,
    });
  },
  component: SettingsRedirectPage,
});
